import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Button, Typography, Divider} from 'views/components';
import {CheckCircle, ErrorOutline, Edit as EditIcon} from 'views/icons';

import View from './ViewBio';
import Edit from './EditBio';

const ViewEdit = (props) => {
  const {
    bioQuestions,
    title,
    saveBioQuestions,
    ViewComponent,
    EditComponent,
    editDisabled = false,
    ...restProps
  } = props;

  const [isComplete, setIsComplete] = React.useState(null);
  const [mode, setMode] = React.useState('VIEW');

  return (
    <Box
      sx={{
        borderRadius: 3,
        boxShadow: '0px 2px 6px rgba(0,0,0,0.1)',
        marginX: 2,
        paddingX: 2,
        paddingTop: 1.5,
        paddingBottom: 1,
        backgroundColor: 'white',
      }}
    >
      {/* Header */}
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        {
          isComplete === true &&
          <CheckCircle size={24} sx={{color: '#22c55e'}} />
        }
        {
          isComplete === false &&
          <ErrorOutline size={24} sx={{color: '#f44336'}} />
        }
        <Typography variant="h6" sx={{fontWeight: 'bold', flex: 1}}>
          {title}
        </Typography>
        {
          mode === 'VIEW' && !editDisabled &&
          <Button variant="Typography" onClick={() => setMode('EDIT')}>
            <EditIcon size={20} color="#757575" />
          </Button>
        }
      </Stack>

      <Divider sx={{mb: 2}}/>
      {
        mode === 'VIEW' &&
        <View
          ViewComponent={ViewComponent}
          bioQuestions={bioQuestions}
          isComplete={isComplete}
          setIsComplete={setIsComplete}
          {...restProps}
        />
      }
      {
        mode === 'EDIT' &&
        <Edit
          EditComponent={EditComponent}
          bioQuestions={bioQuestions}
          isComplete={isComplete}
          setIsComplete={setIsComplete}
          changeToView={() => setMode('VIEW')}
          saveBioQuestions={saveBioQuestions}
          {...restProps}
        />
      }

    </Box>
  );
};

ViewEdit.propTypes = {
  bioQuestions: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  saveBioQuestions: PropTypes.func.isRequired,
  ViewComponent: PropTypes.elementType.isRequired,
  EditComponent: PropTypes.elementType,
  editDisabled: PropTypes.bool,
};

export default React.memo(ViewEdit);
